module.exports = __webpack_public_path__ + "static/img/pin-spray-request-active.f35b787.svg";